<article class="flex h-16 w-80 rounded pl-6 pr-4 py-2 items-center bg-primary-green-2">
    <div>
        <p class="font-bold text-sm">{{ literalService.get(title, true) }}</p>
        <p class="font-normal text-sm">{{ literalService.get(text, true) }}</p>
    </div>
</article>